import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-awards-reportcards',
  templateUrl: './reportcards.component.html',
  styleUrls: ['./reportcards.component.scss']
})
export class ReportcardsComponent implements OnInit {

  reportcards: any;
  @Input() month = null;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getReportCards();

  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    //console.log(changes);
    this.getReportCards();
  }
  getReportCards(){

    this.okService.get("awards/reportcards",{month:this.month})
    .subscribe((data) => {

      this.reportcards = data.body;

      //console.log('getReportCards', data);

    });

  }

}
